import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSocPerformanceResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitSocResultInput;
}>;


export type SubmitSocPerformanceResultMutation = (
  { __typename: 'Mutation' }
  & { submitSocResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitSocResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & SocPerformanceResultFragment
    )> }
  ) }
);

export type SocPerformanceResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'March20kmResult' } | (
    { __typename: 'SocResult' }
    & Pick<SchemaTypes.SocResult, 'timingSec' | 'result'>
  ) | { __typename: 'WeightResult' } }
);

export const SocPerformanceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SocPerformanceResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on SocResult {
      timingSec
      result
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitSocPerformanceResultDocument = /*#__PURE__*/ gql`
    mutation SubmitSocPerformanceResult($input: SubmitSocResultInput!) {
  submitSocResult(input: $input) {
    ... on SubmitSocResultSuccessfulResponse {
      result {
        ...SocPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SocPerformanceResultFragmentDoc}`;
export type SubmitSocPerformanceResultMutationFn = Apollo.MutationFunction<SubmitSocPerformanceResultMutation, SubmitSocPerformanceResultMutationVariables>;

/**
 * __useSubmitSocPerformanceResultMutation__
 *
 * To run a mutation, you first call `useSubmitSocPerformanceResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSocPerformanceResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSocPerformanceResultMutation, { data, loading, error }] = useSubmitSocPerformanceResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSocPerformanceResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSocPerformanceResultMutation, SubmitSocPerformanceResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSocPerformanceResultMutation, SubmitSocPerformanceResultMutationVariables>(SubmitSocPerformanceResultDocument, options);
      }
export type SubmitSocPerformanceResultMutationHookResult = ReturnType<typeof useSubmitSocPerformanceResultMutation>;
export type SubmitSocPerformanceResultMutationResult = Apollo.MutationResult<SubmitSocPerformanceResultMutation>;
export type SubmitSocPerformanceResultMutationOptions = Apollo.BaseMutationOptions<SubmitSocPerformanceResultMutation, SubmitSocPerformanceResultMutationVariables>;